import { z } from 'zod'

import { whitelabelsList } from './constants'

/** Zod schema for validating whitelabel identifiers. */
export const whitelabelSchema = z.enum(whitelabelsList)
